import React from 'react';
import { motion } from 'framer-motion';

const UserReviewsSection = () => {
    const userReviews = [
        {
            name: "Muskan Chaurasia",
            role: "Student",
            review: "It is one of the best dataset generator tool that provides correct data unlike other tools present online that generate incorrect data."
        },
        {
            name: "Vaishnavi",
            role: "Student",
            review: "It helped for me my project a lot!"
        },
        {
            name: "Jennifer Janet N",
            role: "User",
            review: "Very fast generation!"
        },
        {
            name: "User",
            role: "Data Analyst",
            review: "The generated data exceeded my expectations! Excellent quality and highly relevant to my research needs."
        },
        {
            name: "User",
            role: "Student",
            review: "Wonderful AI, I like it. Good generations!"
        }
    ];

    const getAnimationProps = (index) => {
        return {
            initial: { opacity: 0, y: 50 },
            whileInView: { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: { duration: 0.5, delay: index * 0.1 }
        };
    };

    return (
        <div className="py-20 bg-gradient-to-br from-blue-50 via-indigo-50 to-white relative overflow-hidden">
            {/* Subtle background pattern */}
            <div
                className="absolute inset-0 opacity-5"
                style={{
                    backgroundImage: 'radial-gradient(circle, #3B82F6 1px, transparent 1px)',
                    backgroundSize: '32px 32px'
                }}
            />

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-blue-600 mb-4">
                        What Our Users Are Saying
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Hear from students and developers who are using DataCreator AI for their projects
                    </p>
                </motion.div>

                {/* Reviews Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
                    {userReviews.map((review, index) => (
                        <motion.div
                            key={index}
                            {...getAnimationProps(index)}
                            whileHover={{ scale: 1.03, y: -5 }}
                            className="group relative"
                        >
                            {/* Card */}
                            <div className="h-full bg-blue-600 rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col relative overflow-hidden">
                                {/* Quote icon background */}
                                <div className="absolute top-2 left-4 text-white/10 text-7xl font-serif leading-none select-none">
                                    "
                                </div>

                                {/* Review Content */}
                                <div className="relative z-10 flex-grow mb-4">
                                    <p className="text-white text-base leading-relaxed italic">
                                        "{review.review}"
                                    </p>
                                </div>

                                {/* Divider */}
                                <div className="border-t border-white/30 my-4"></div>

                                {/* Author Info */}
                                <div className="relative z-10">
                                    <p className="text-white font-bold text-lg mb-1">
                                        {review.name}
                                    </p>
                                    <p className="text-blue-100 text-sm">
                                        {review.role}
                                    </p>
                                </div>

                                {/* Decorative gradient overlay */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                {/* Call to action */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="text-center mt-12"
                >
                    <p className="text-gray-600 text-sm">
                        Join hundreds of users creating amazing datasets with DataCreator AI
                    </p>
                </motion.div>
            </div>
        </div>
    );
};

export default UserReviewsSection;
